const { registerCheckoutFilters } = window.wc.blocksCheckout;

const callback = (value) => {
  console.log(value);
};

// export const registerFilters = () => {
//   registerCheckoutFilters("epaka-pl", {
//     _epakaP: callback,
//     _epakaPD: callback,
//   });
// };
